import { documentIdv3Requests } from "./api/documentId.requests";

export const workspaceRequests = {
  getTemplateDocumentMetadata: documentIdv3Requests.getRawWorkspaceMetadata,
};
